import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { AttachmentOwnerType } from '../../../types/Attachment';

interface IAttachmentDestroyRequest {
  type: AttachmentOwnerType;
  uuid: string;
  keys: string[];
}

const destroyAttachments = async (requestData: IAttachmentDestroyRequest) => {
  const response = await CustomAxios.delete(`attachments`, {params: requestData});
  const { data } = response;
  return data;
};

type useCreateAttachmentProps = {
  type: AttachmentOwnerType;
  uuid: string;
  onSuccessCallback: () => void;
};

export function useDestroyAttachments({ type, uuid, onSuccessCallback }: useCreateAttachmentProps) {
  return useMutation({
    mutationFn: (keys: string[]) => destroyAttachments({type, uuid, keys}),
    onSuccess: () => {
      // fetch the attachments again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAttachments, type, uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => console.log(err?.response),
  });
}
